import { Injectable } from '@angular/core';
import { ITransformationConfiguration } from '../interfaces/ITransformationComponent';
import { TransformationType } from '../../model/dataflow/transformationtype';
import { TransformationMetaModel } from './transformation-meta-model';

@Injectable({
    providedIn: 'root'
})
export class TransformationRegistryService {
    private _transformationConfigurations = new Map<TransformationType, ITransformationConfiguration>();

    constructor() {
        this._populateKnownTransformationTypes();
    }

    public getAllTransformationConfigurations(): ITransformationConfiguration[] {
        const allTransformationConfigurations: ITransformationConfiguration[] = [];
        this._transformationConfigurations.forEach((transformationConfiguration) => {
            allTransformationConfigurations.push(transformationConfiguration);
        });
        return allTransformationConfigurations;
    }

    public getTransformationConfiguration(transformationType: TransformationType): ITransformationConfiguration {
        const configuration = this._transformationConfigurations.get(transformationType);
        if (configuration) {
            return configuration;
        }
        throw new Error(`${transformationType.name} not found in transformation-registery`);
    }

    public registerTransformationConfiguration(transformationConfiguration: ITransformationConfiguration): void {
        if (transformationConfiguration.transformationType && (
            transformationConfiguration.transformationType.name === 'extend')) {
            return;
        }
        this._transformationConfigurations.set(transformationConfiguration.transformationType, transformationConfiguration);
    }

    private _populateKnownTransformationTypes(): void {
        TransformationMetaModel.transformationConfigurations.forEach((transformationConfiguration) => {
            this.registerTransformationConfiguration(transformationConfiguration);
        });
    }
}
